/**
 * The Bapuji Educational Association — BIET's parent trust — as published at
 * bietdvg.edu/Bapuji_educational_association.
 *
 * Note the association's office-bearers are NOT the same roster as board.ts:
 * that file carries BIET's own governing body (Chairman, Secretary, Members),
 * while these are the association's elected officers. The same people appear
 * in both under different titles — Sri S.S. Mallikarjuna is "Chairman" on the
 * institute's board and "Hon. Secretary" of the association.
 *
 * The source page said "over 45" institutions at last check; older copy on
 * this site said "50+" and the Principal's letter says "around 40". The
 * association has since grown — per the site owner, 60+ is the current
 * figure to publish.
 */
import type { Media } from "@zivin-labs/site-content";

export const BEA = {
  founded: 1958,
  /** What the association was set up to do, per its own page. */
  founding: "started to open a first-grade college in Davangere",
  institutions: "60+",
  /** Levels the trust's institutions span, nursery through postgraduate. */
  fields: [
    "Schools and pre-university",
    "Engineering and diploma",
    "Medical and nursing",
    "Dental",
    "Pharmacy",
    "Arts, science and commerce",
  ],
  city: "Davanagere, Karnataka",
} as const;

/**
 * The association's headquarters on Shamanur Road, carried over from the
 * institute's previous site and re-ingested through scripts/ingest-images.py.
 * Shown in the About page's Bapuji Educational Association section.
 */
export const BEA_HQ_PHOTO: Media = {
  url: "sites/biet/about/bea-headquarters.jpg",
  alt: "The Bapuji Educational Association headquarters building in Davanagere",
  width: 2560,
  height: 1706,
};

export interface BeaOfficer {
  name: string;
  role: string;
}

/** The association's governing council, in the order its own page lists them. */
export const BEA_COUNCIL: BeaOfficer[] = [
  { name: "Sri R.L. Umashankar", role: "President" },
  { name: "Smt K.A. Girijamma", role: "Vice President" },
  { name: "Sri S.S. Mallikarjuna", role: "Hon. Secretary" },
  { name: "Dr. Prabha Mallikarjuna", role: "Joint Secretary" },
  { name: "Sri A.S. Niranjan", role: "Treasurer" },
  { name: "Sri A.S. Veeranna", role: "Member" },
  { name: "Sri Sampanna Muthalik", role: "Member" },
];
